import Alpine from '@alpinejs/csp';
const INTERVAL_CHECK = 60 * 5 * 1000;

var offset = null;
var nextCheck = null;
var fetching = false;

function _updateOffset() {
  if (fetching) {
    return;
  }
  fetching = true;
  const startTime = Date.now();

  fetch("/__timestamp__/")
    .then((response) => response.json())
    .then((data) => {
      const endTime = Date.now();
      const roundTripTime = endTime - startTime;

      // Adjust server time by half the round-trip time
      const serverTime = data.timestamp + roundTripTime / 2;
      const localTime = Date.now();

      offset = serverTime - localTime;
      nextCheck = localTime + INTERVAL_CHECK;

      fetching = false;
    })
    .catch(() => {
      fetching = false;
    });

}
export function getServerTimestamp() {
  const now = Date.now();
  if (offset === null || (nextCheck && nextCheck <= now)) {
    _updateOffset();
  }

  if (offset === null) {
    return null;
  }

  // Floor to seconds to only trigger new HTML render when second change
  return Math.floor((now + offset) / 1000) * 1000;
}

export function startStoreServerTimestampUpdate() {
  try {
    // Run fast interval to get first time soon as possible
    const initInterval = setInterval(() => {
      const serverTimestamp = getServerTimestamp();
      if (serverTimestamp !== null) {
        Alpine.store("serverTimestamp", serverTimestamp);
        clearInterval(initInterval);
      }
    }, 25);

    // Normal interval to update time
    setInterval(() => {
      Alpine.store("serverTimestamp", getServerTimestamp() || 0);
    }, 250);
  } catch (er) {
    console.log(er);
  }
}
